export class PlanType {
    newPlan = true;
    mitsumori = false;
    chumon = false;
    mitsumoriChumon = false; // New -> save mitsumori -> save chuon -> get mitsumori
    chumonMitsumori = false; // New -> save mitsumori -> save chuon -> get chumon
    mitsumoriDeleted = false;
    chumonCancel = false;
}



// WEBPACK FOOTER //
// ./src/app/models/plan/plantype.ts